module.exports = __webpack_public_path__ + "img/image1.1489610a.png";